import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Crash beacon: unhandled errors reach the server log instead of dying
// silently in a beta user's console.
window.addEventListener('error', (e) => {
  try {
    fetch('/api/client-error', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: String(e.message), stack: e.error?.stack, url: window.location.pathname }),
    }).catch(() => {});
  } catch {}
});
window.addEventListener('unhandledrejection', (e) => {
  try {
    fetch('/api/client-error', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: 'unhandledrejection: ' + String(e.reason), stack: e.reason?.stack, url: window.location.pathname }),
    }).catch(() => {});
  } catch {}
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
